import React from 'react';
import {BUILD_TYPE, getBuildType, setBuildType,} from '@voltmoney/micro-frontend';
import packageJson from './package.json';
import {LogBox, Text, View} from 'react-native';
import WebPartnersApp from './web.partners';
import AppWeb from './AppWeb';
import PlatformDashboard from './platform_dashboard';

LogBox.ignoreLogs([
  'DevTools failed to load source map',
  'Warning:',
  'Theme not initialized',
  'setNativeProps is deprecated',
  'Theme not initialized',
  'Warning: forwardRef render functions accept exactly two parameters',
  'Internal Server Error',
  'Manifest: Line: 1, column: 1, Syntax error.',
  "[Violation] Added non-passive event listener to a scroll-blocking 'wheel' event",
  'Uncaught TypeError:',
  'Warning: Invalid DOM property',
]);
console.info('*** App Version-> ', packageJson.version, getBuildType());

/*** Change the build type */
setBuildType(BUILD_TYPE.PARTNER_PRODUCTION);
const BuildType: React.FunctionComponent = () => {
  const buildType = getBuildType();
  switch (buildType) {
    case BUILD_TYPE.BORROWER_STAGING:
    case BUILD_TYPE.BORROWER_PRODUCTION:
    case BUILD_TYPE.BORROWER_TEST_STAGING:
    case BUILD_TYPE.BORROWER_QA_STAGING:
      return <AppWeb />;
    case BUILD_TYPE.PARTNER_STAGING:
    case BUILD_TYPE.PARTNER_PRODUCTION:
      return <WebPartnersApp />;
    case BUILD_TYPE.PLATFORM_STAGING:
    case BUILD_TYPE.PLATFORM_PRODUCTION:
      return <PlatformDashboard />;
    default:
      return (
        <View style={{flex: 1}}>
          <Text>BuildType: {buildType} Not supported</Text>
        </View>
      );
  }
};

BuildType.propTypes = {};

export default BuildType;
